var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketRoundRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.998 255.995C143.998 123.336 52.208 55.147 51.301 54.46C47.738 51.866 46.926 46.866 49.52 43.303C52.114 39.709 57.146 38.959 60.677 41.491C64.74 44.428 160 114.867 160 255.995S64.74 467.563 60.677 470.5C59.271 471.5 57.614 472 55.989 472C53.52 472 51.082 470.844 49.52 468.688C46.926 465.125 47.738 460.125 51.301 457.531C52.208 456.844 143.998 388.655 143.998 255.995Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketRoundRight);
export default __webpack_public_path__ + "static/media/bracket-round-right.12cc781813d22b55be77234108c6998f.svg";
export { ForwardRef as ReactComponent };